import { useEffect, useRef, useState } from 'react';

export function useObjectUrls(files: File[]): Map<File, string> {
  const [urls, setUrls] = useState(() => new Map<File, string>());
  const urlsRef = useRef(urls);
  urlsRef.current = urls;

  useEffect(() => {
    setUrls(previous => {
      const next = new Map(previous);
      const activeFiles = new Set(files);
      let changed = false;

      files.forEach(file => {
        if (!next.has(file)) {
          next.set(file, URL.createObjectURL(file));
          changed = true;
        }
      });
      next.forEach((url, file) => {
        if (!activeFiles.has(file)) {
          URL.revokeObjectURL(url);
          next.delete(file);
          changed = true;
        }
      });

      return changed ? next : previous;
    });
  }, [files]);

  useEffect(
    () => () => {
      urlsRef.current.forEach(url => URL.revokeObjectURL(url));
    },
    [],
  );

  return urls;
}
